const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  marketChange: 'market-change',
  facetsUpdate: 'facets-update',
  wishlistCollectionItemAdded: 'wishlist-collection-item-added',
  wishlistCollectionItemRemoved: 'wishlist-collection-item-removed',
  customerWishlistCollectionItemAdded: 'customer-wishlist-collection-item-added',
  customerWishlistCollectionItemRemoved: 'customer-wishlist-collection-item-removed',
  wishlistProductItemAdded: 'wishlist-product-item-added',
  wishlistProductItemRemoved: 'wishlist-product-item-removed',
  customerWishlistProductItemAdded: 'customer-wishlist-product-item-added',
  customerWishlistProductItemRemoved: 'customer-wishlist-product-item-removed',
  wishlistLoaded: 'wishlist-loaded',
  wishlistUpdated: 'wishlist-updated',
  wishlistChange: 'wishlist-change',
  variantOrderMaxQtyReached: 'variant-order-max-qty-reached',
  loadMoreFinished: 'load-more-finished',
  predictiveSearchPerformed: 'predictive-search-performed',
  wishlistItemSizeUpdated: 'wishlist-item-size-updated',
  passwordStrengthChecked: 'password-strength-checked',
  sizeGuideOpen: 'size-guide-open',
  sizeGuideClosed: 'size-guide-closed',
  sizeGuideRequested: 'size-guide-requested'
};
